var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResponsibilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.203,
    height: 23.109,
    viewBox: "0 0 28.203 23.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2349",
    "data-name": "Group 2349",
    transform: "translate(-325.184 -585.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person-stalker",
    transform: "translate(322.934 581.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3879",
    "data-name": "Path 3879",
    d: "M27.278,18.633c-2.066-.784-1.941-.469-1.941-1.921,0-.938.464-.594.759-2.38.115-.7.209-.234.454-1.363.13-.589-.09-.634-.06-.913s.05-.534.1-1.108a2.66,2.66,0,0,0-2.864-2.595,2.66,2.66,0,0,0-2.864,2.595c.045.579.075.828.1,1.108s-.189.324-.06.913c.245,1.128.339.654.454,1.363.295,1.786.754,1.447.754,2.38,0,.669.155.948-.744,1.373.27.1.584.209.963.354,2.715,1.033,2.65,2.036,2.72,2.51.05.324.075,2.909.085,3.833h4.874s0-4.017-.075-4.486c-.055-.369-.549-.858-2.655-1.661Z",
    transform: "translate(-5.401 -1.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    d: "M18.469,23.661s0-.7-.01-1.517c-.01-.928-.035-2-.085-2.315-.075-.474-.713-1.108-3.423-2.141-.374-.14-.688-.255-.963-.354-1.661-.589-1.542-.784-1.542-2.4,0-1.213.6-.424.978-2.725.15-.908.27-.3.584-1.757.17-.759-.115-.818-.08-1.182s.07-.688.13-1.432a3.431,3.431,0,0,0-3.7-3.349,3.431,3.431,0,0,0-3.7,3.349c.06.744.1,1.068.135,1.432s-.25.419-.08,1.182c.319,1.452.439.848.589,1.757.379,2.3.973,1.512.973,2.725,0,1.877.165,1.737-2.505,2.75-2.71,1.032-3.349,1.666-3.423,2.14-.1.6-.1,3.833-.1,3.833Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M6.16,17.836.265,11.942a.907.907,0,0,1,0-1.283L1.548,9.377a.907.907,0,0,1,1.283,0L6.8,13.347l8.505-8.505a.907.907,0,0,1,1.283,0l1.283,1.283a.907.907,0,0,1,0,1.283L7.443,17.836a.907.907,0,0,1-1.283,0Z",
    transform: "translate(335.249 590.84)",
    fill: "#00c742"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsibilities);
export default __webpack_public_path__ + "static/media/responsibilities.64c6202f0453b8b5c271046196d6a906.svg";
export { ForwardRef as ReactComponent };